// src/stores/flightstore.js
import { reactive } from "vue";

// 1. Intentamos recuperar los datos de la última búsqueda desde sessionStorage
const savedSearchPayload = sessionStorage.getItem("flightSearchPayload");
const savedSearchId = sessionStorage.getItem("flightSearchId");

// 2. Creamos el store reactivo.
// La lista de vuelos SIEMPRE empieza vacía.
// El payload de búsqueda se carga si existía en la sesión.
export const flightStore = reactive({
  flights: [],
  searchId: savedSearchId ? JSON.parse(savedSearchId) : null,
  searchPayload: savedSearchPayload ? JSON.parse(savedSearchPayload) : null,
});

// Función para guardar los resultados
export function setFlightResults(responseData, payload) {
  // La API ahora devuelve un objeto { searchId: '...', flights: [...] }
  flightStore.flights = responseData.flights || [];
  flightStore.searchId = responseData.searchId || null;
  flightStore.searchPayload = payload;

  // 3. Cada vez que guardamos resultados, persistimos el searchId y el payload
  if (payload) {
    sessionStorage.setItem("flightSearchPayload", JSON.stringify(payload));
  } else {
    sessionStorage.removeItem("flightSearchPayload");
  }
}

if (flightStore.searchId) {
  sessionStorage.setItem("flightSearchId", JSON.stringify(flightStore.searchId));
} else {
  sessionStorage.removeItem("flightSearchId");
}

// Función para limpiar los resultados cuando ya no se necesiten
export function clearFlightResults() {
  flightStore.flights = [];
  flightStore.searchPayload = null;
  flightStore.searchId = null;
  // 4. Al limpiar, también borramos la "memoria" del sessionStorage
  sessionStorage.removeItem("flightSearchPayload");
  sessionStorage.removeItem("flightSearchId");
}
